// import styles from "./PreFunctionArea.module.css";

// export default function PreFunctionArea({ ballroom }) {
//   const preFunction = ballroom?.pre_function_area;

//   if (!preFunction) return null;

//   const image =
//     preFunction.images?.length > 0
//       ? preFunction.images[0].image
//       : null;

//   const hasDescription = !!preFunction.description;
//   const hasArea = !!preFunction.area;
//   const hasCapacity = !!preFunction.capacity;

//   return (
//     <section className={styles.section}>
//       <div className={styles.container}>
//         <h2 className={styles.heading}>
//           Pre-Function Area (Foyer)
//         </h2>

//         <div className={styles.content}>
//           {image && (
//             <div className={styles.imageWrapper}>
//               <img
//                 src={image}
//                 alt="Pre Function Area"
//                 className={styles.image}
//               />
//             </div>
//           )}

//           <div className={styles.details}>
//             {hasDescription && (
//               <p className={styles.description}>
//                 {preFunction.description}
//               </p>
//             )}

//             {(hasArea || hasCapacity) && (
//               <div className={styles.grid}>
//                 {hasArea && (
//                   <div className={styles.card}>
//                     <span>Area</span>
//                     <h3>{preFunction.area} sq.ft</h3>
//                   </div>
//                 )}

//                 {hasCapacity && (
//                   <div className={styles.card}>
//                     <span>Capacity</span>
//                     <h3>{preFunction.capacity} Guests</h3>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }


import styles from "./PreFunctionArea.module.css";

export default function PreFunctionArea({ ballroom }) {
  const preFunction = ballroom?.pre_function_area;

  if (!preFunction) return null;

  const image =
    preFunction.images?.length > 0
      ? preFunction.images[0].image
      : null;

  const hasDescription = !!preFunction.description;
  const hasArea = !!preFunction.area;
  const hasCapacity = !!preFunction.capacity;

  // Format dimensions
  const dimensions = preFunction.dimensions
    ? /\bft\b/i.test(preFunction.dimensions)
      ? preFunction.dimensions
      : `${preFunction.dimensions} ft`
    : preFunction.length && preFunction.width
      ? `${preFunction.length} × ${preFunction.width}${
          preFunction.height ? ` × ${preFunction.height}` : ""
        } ft`
      : null;

  const hasDimensions = !!dimensions;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          Pre-Function Area (Foyer)
        </h2>

        <div className={styles.content}>
          {image && (
            <div className={styles.imageWrapper}>
              <img
                src={image}
                alt="Pre Function Area"
                className={styles.image}
              />
            </div>
          )}

          <div className={styles.details}>
            {hasDescription && (
              <p className={styles.description}>
                {preFunction.description}
              </p>
            )}

            {(hasDimensions || hasArea || hasCapacity) && (
              <div className={styles.grid}>

                {hasDimensions && (
                  <div className={styles.card}>
                    <span>Dimensions</span>
                    <h3>{dimensions}</h3>
                  </div>
                )}

                {hasArea && (
                  <div className={styles.card}>
                    <span>Area</span>
                    <h3>{preFunction.area} sq.ft</h3>
                  </div>
                )}

                {hasCapacity && (
                  <div className={styles.card}>
                    <span>Capacity</span>
                    <h3>{preFunction.capacity} Guests</h3>
                  </div>
                )}

              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
